import styled from "@yb/styled-px2rem";
import ErrorThumbnail from "@FRAMEWORK/ui/mobile/thumbnail/ErrorThumbnail";

const ProductListThumbnail = styled.div`
	position: relative;
	width: 100%;
	max-width: 100%;
	margin-bottom: 10px;
	${ErrorThumbnail}

	> span {
		${ErrorThumbnail};
	}
`;

export default ProductListThumbnail;
